/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2025-12-26_the-real-constraint-in-product-development.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/the-real-constraint-in-product-development.mdx';

const metadata = {
  title: "The Real Constraint in Product Development: Known and Unknown Unknowns",
  date: "2025-12-26",
  author: "Christian Battaglia",
  articleNumber: 2,
  seoDescription: "What we're actually trading off against isn't effort, points, or quality; it's uncertainty. Learn how known vs unknown unknowns drive friction between business, product, and engineering.",
  linkedinUrl: "https://www.linkedin.com/pulse/real-constraint-product-development-known-unknown-christian-battaglia-i16ee",
  heroImage: "/prodeng/the-real-constraint-in-product-development.webp",
  readTime: "3 min read",
  tags: ["product engineering","uncertainty","product development","known unknowns","software engineering","product management","decision-making","engineering leadership"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/the-real-constraint-in-product-development')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/the-real-constraint-in-product-development',
    image: '/og/prodeng/the-real-constraint-in-product-development.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
